import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useStore, useToast, useResource, usePage, useAuth } from "@/comn/hooks";
import { APIS, SF_USR_INFO, URLS } from "@/tz/go/egaz/osci/ptl/usr/info/services/OsciMyInfoService";

/*
 * Chnage My Information
 * !== 나의정보수정  ==!
 */
export const OSCI0103002Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage();
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const { pgeStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const auth = useAuth();

    useResource({
        defaultSchema: [{ area: "cntyCd" }, { area: "orgCd" }, { area: "cstmCd" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // My Information !== 나의정보 ==!
        usrInfo: useForm({
            defaultSchema: SF_USR_INFO,
            defaultValues: { ...pgeStore?.form },
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Search My Information !==  나의정보조회 ==!
        getOrgUsrInfo: useFetch({
            api: (data) => APIS.getMyInfo(auth.get("usrIdntfId")),
            enabled: !!auth.get("usrIdntfId"),
            onSuccess: (data) => {
                const myInfo = data.myInfo.content;
                form.usrInfo.setValues(myInfo);
            },
            onError: (error) => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getOrgUsrInfo.fetch();
        form.usrInfo.setEditable(false);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.usrInfo.schema.psnTin} />
                            <Group.Control {...form.usrInfo.schema.orgCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.usrInfo.schema.usrNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.usrInfo.schema.orgRppnYn} />
                            {/* <Group.Control {...form.usrInfo.schema.frgnrYn} /> */}
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.usrInfo.schema.aplcCntyCd} />
                            <Group.Control {...form.usrInfo.schema.usrMoblNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.usrInfo.schema.usrEmlAddr} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.usrInfo.schema.rsdtAddr} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Right>
                            <Button
                                role="edit"
                                onClick={() => {
                                    navigate(`${URLS.osci0103003s}`);
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
        </Page>
    );
};
